module.exports = __webpack_public_path__ + "img/food3.774373b0.png";